import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'

const StatusFilter = ({ filterStatus, setFilterStatus }) => {
  const options2 = [
    {
      id: 1,
      label: 'Active',
      value: '1',
    },
    {
      id: 2,
      label: 'Closed',
      value: '-1',
    },
    {
      id: 3,
      label: 'Draft',
      value: '0',
    },
  ]

  const onStatusChange = values => {
    setFilterStatus([values[values?.length - 1]])
  }

  return (
    <Wrapper>
      <FilterCheckBoxComp
        value={filterStatus}
        options={options2}
        onChange={onStatusChange}
      />
    </Wrapper>
  )
}

export default StatusFilter
